<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Update Grade Step</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign:</span>
            </div>
            {{ gradeStepDescription.campaign_name }}
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="step_name"
                v-model="gradeStepDescription.step_name"
                v-validate="'required'"
                data-vv-as="Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('step_name')"
              >{{ errors.first("step_name") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                name="description"
                class="w-full"
                v-model="gradeStepDescription.step_description"
                v-validate="'required'"
                data-vv-as="GradeStep"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Order:</span>
            </div>
            <div class="vx-col">
              <vs-input-number
                class="w-full"
                name="order_by"
                v-model="gradeStepDescription.order_by"
                v-validate="'required'"
                data-vv-as="Order"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('order_by')"
              >{{ errors.first("order_by") }}</span
            >
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span> Account Fields:</span>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <span><h6>Master Field</h6></span>
              <div
                class="mt-5"
                v-for="(v, index) in master_account_fields"
                :key="index"
              >


              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" gradeStepDescription.master_account_field"
              :checked="
              gradeStepDescription.master_account_field != null &&
              gradeStepDescription.master_account_field.some(e => e.name == v.name)
              "
             
            />
            {{ v.name }}


             
              </div>

              <!-- {{master_account_fields}} -->
            </div>
            <div class="vx-col sm:w-1/4 w-full">
              <span><h6>Campaign Field</h6></span>
              <div
                class="mt-5"
                v-for="(v, index) in campaign_account_fields"
                :key="index"
              >


              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" gradeStepDescription.campaign_account_field"
              :checked="
              gradeStepDescription.campaign_account_field != null &&
              gradeStepDescription.campaign_account_field.some(e => e.name == v.name)
              "
             
            />
            {{ v.name }}


              
              </div>

              <!-- {{master_account_fields}} -->
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <span><h6>Client Field</h6></span>
              <div
                class="mt-5"
                v-for="(v, index) in client_account_fields"
                :key="index"
              >



              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" gradeStepDescription.client_account_field"
              :checked="
              gradeStepDescription.client_account_field != null &&
              gradeStepDescription.client_account_field.some(e => e.name == v.name)
              "
             
            />
            {{ v.name }}


               
              </div>

              <!-- {{master_account_fields}} -->
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span> Contact Fields:</span>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <span><h6>Master Field</h6></span>
              <div
                class="mt-5"
                v-for="(v, index) in master_contact_fields"
                :key="index"
              >


              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" gradeStepDescription.master_contact_field"
              :checked="
              gradeStepDescription.master_contact_field != null &&
              gradeStepDescription.master_contact_field.some(e => e.name == v.name)
              "
             
            />
            {{ v.name }}


            
              </div>

              <!-- {{master_account_fields}} -->
            </div>
            <div class="vx-col sm:w-1/4 w-full">
              <span><h6>Campaign Field</h6></span>
              <div
                class="mt-5"
                v-for="(v, index) in campaign_contact_fields"
                :key="index"
              >


              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" gradeStepDescription.campaign_contact_field"
              :checked="
              gradeStepDescription.campaign_contact_field != null &&
              gradeStepDescription.campaign_contact_field.some(e => e.name == v.name)
              "
             
            />
            {{ v.name }}



              
              </div>

              <!-- {{master_account_fields}} -->
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <span><h6>Client Field</h6></span>
              <div
                class="mt-5"
                v-for="(v, index) in client_contact_fields"
                :key="index"
              >


              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" gradeStepDescription.client_contact_field"
              :checked="
              gradeStepDescription.client_contact_field != null &&
              gradeStepDescription.client_contact_field.some(e => e.name == v.name)
              "
             
            />
            {{ v.name }}


             
              </div>

              <!-- {{master_account_fields}} -->
            </div>
          </div>


          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span> Opportunity Fields:</span>
            </div>



            <div class="vx-col sm:w-1/4 w-full">



              <div
                class="mt-5"
                v-for="(v, index) in opportunity_fields"
                :key="index"
              >



              <input
              type="checkbox"
              class="mr-2"
              :value="v"
              :id="v.uuid"
               v-model=" gradeStepDescription.opportunity_field"
              :checked="
              gradeStepDescription.opportunity_field != null &&
              gradeStepDescription.opportunity_field.some(e => e.name == v.name)
              "
             
            />
            {{ v.name }}


              </div>

            </div>
         
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Update</vs-button
              >
            </div>
          </div>
          <vs-divider class="m-5" />

          <DataGrid :context="'GradeSteps'" 
            ref="grade_steps"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleGradeManagement from "@/store/grade-management/moduleGradeManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      campaign_required: null,
      selected_campaign: [],
      companySearchComponentKey: 0,
      columnDefs: [
        {
          headerName: "Campaign",
          flex: 1,
          field: "campaign_name",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Step",
          flex: 1,
          field: "step_name",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          flex: 1,
          field: "step_description",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          flex: 1,

          headerName: "Order",
          field: "order_by",

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          flex: 1,

          headerName: "Fields",
          field: "field",

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      opportunity_fields: [],
      selected_opportunity_fields:[],

      campaign_account_fields: [],
      master_account_fields: [],
      client_account_fields: [],
      campaign_contact_fields: [],
      master_contact_fields: [],
      client_contact_fields: [],
      dataSource: {},
      records: [],
      selected: [],
      allGrades: [],
      abilities: null,
      grade_steps: {
        step_name: null,
        step_description: null,
        order_by: 0,
        campaign: [],
        fields: [],
        master_account_field: [],
        client_account_field: [],
        campaign_account_field: [],
        master_contact_field: [],
        client_contact_field: [],
        campaign_contact_field: []
      },
      selected_account_fields: [],
      selected_contact_fields: [],
      already_selected_fields: [],
      gradeStepDescription: [],
      grade_step_id: null
    };
  },
  components: {
    "v-select": vSelect,
    moduleGradeManagement,
    DataGrid,
    CampaignAutocomplete
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleGradeManagement.isRegistered) {
      this.$store.registerModule("GradesManagement", moduleGradeManagement);
      moduleGradeManagement.isRegistered = true;
    }

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  },
  mounted() {
    this.grade_step_id = this.$route.params.gradeStepId;
    this.fetchGradeStep();
  },
  watch: {},
  methods: {
    fetchGradeStep() {
      let self = this;
      this.$store
        .dispatch("GradesManagement/fetchGradeStep", self.grade_step_id)
        .then(res => {
          let result = JSON.parse(res.data);
          self.gradeStepDescription = result[0];

          self.getSelectedAccountFields();
          self.getSelectedContactFields();
          self.getSelectedOpportunityFields();

          // this.getAlreadySelectedFields();


          // self.gradeStepDescription.field.map(function(ele){
          //    if (ele == self.master_contact_fields.name) {
          //       selected_option.push(ele);
          //   }
          // })

          //   let selected_option = [];

          //   self.self.gradeStepDescription.field.forEach(function(ele) {
          //     if (
          //       self.outcomeDescription.action_type_outcome_option.includes(
          //         ele.slug
          //       )
          //     ) {
          //       selected_option.push(ele);
          //     }
          //   });

          //   self.outcomeDescription.action_type_outcome_option = selected_option;

          // console.log( self.gradeStepDescription.master_account_field)
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSelectedAccountFields() {
      let self = this;
      let selected_campaign = {};
      selected_campaign.id = self.gradeStepDescription.campaign_id;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedAccountFields",
          selected_campaign
        )
        .then(response => {
          self.selected_account_fields = JSON.parse(response.data);

          self.selected_account_fields.forEach(function(ele) {
            ele.field_from = ele.field_type

            if (ele.field_type == 'master_field' && ele.level == 'account') {
              self.master_account_fields.push(ele);


              let selected_account_master_field = [];
              self.master_account_fields.forEach(function(ele) {
                if (
                  self.gradeStepDescription.field.some(
                    item => item === ele.name
                  )
                ) {
                  selected_account_master_field.push(ele);
                }
                self.gradeStepDescription.master_account_field = selected_account_master_field;


              });
            }
            if (ele.field_type == 'client_field' && ele.level == 'account') {
              self.client_account_fields.push(ele);
              let selected_account_client_field = [];
              self.client_account_fields.forEach(function(ele) {
                if (
                  self.gradeStepDescription.field.some(
                    item => item === ele.name
                  )
                ) {
                  selected_account_client_field.push(ele);
                }
                self.gradeStepDescription.client_account_field = selected_account_client_field;
              });
            }
            if (ele.field_type == 'campaign_field' && ele.level == 'account') {
              self.campaign_account_fields.push(ele);

              let selected_account_campaign_field = [];
              self.campaign_account_fields.forEach(function(ele) {
                if (
                  self.gradeStepDescription.field.some(
                    item => item === ele.name
                  )
                ) {
                  selected_account_campaign_field.push(ele);
                }
                self.gradeStepDescription.campaign_account_field = selected_account_campaign_field;
              });
            }
          });
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getSelectedContactFields() {
      let self = this;
      let selected_campaign = {};
      selected_campaign.id = self.gradeStepDescription.campaign_id;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedAccountFields",
          selected_campaign
        )
        .then(response => {
          self.selected_contact_fields = JSON.parse(response.data);
          self.selected_contact_fields.forEach(function(ele) {
            ele.field_from = ele.field_type

            if (ele.field_type == 'master_field' && ele.level == 'contact') {
              self.master_contact_fields.push(ele);
              let selected_contact_master_field = [];
              self.master_contact_fields.forEach(function(ele) {
                if (
                  self.gradeStepDescription.field.some(
                    item => item === ele.name
                  )
                ) {
                  selected_contact_master_field.push(ele);
                }
                self.gradeStepDescription.master_contact_field = selected_contact_master_field;
              });
            }
            if (ele.field_type == 'client_field' && ele.level == 'contact') {
              self.client_contact_fields.push(ele);
               let selected_contact_client_field = [];
              self.client_contact_fields.forEach(function(ele) {
                if (
                  self.gradeStepDescription.field.some(
                    item => item === ele.name
                  )
                ) {
                  selected_contact_client_field.push(ele);
                }
                self.gradeStepDescription.client_contact_field = selected_contact_client_field;
              });
            }
            if (ele.field_type == 'campaign_field' && ele.level == 'contact') {
              self.campaign_contact_fields.push(ele);
               let selected_contact_campaign_field = [];
              self.campaign_contact_fields.forEach(function(ele) {
                if (
                  self.gradeStepDescription.field.some(
                    item => item === ele.name
                  )
                ) {
                  selected_contact_campaign_field.push(ele);
                }
                self.gradeStepDescription.campaign_contact_field = selected_contact_campaign_field;
              });
            }
          });
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },

    getSelectedOpportunityFields() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedOpportunityFields",
          self.gradeStepDescription.campaign_id
        )
        .then(response => {

          self.opportunity_fields = []

          self.selected_opportunity_fields = JSON.parse(response.data);



          self.selected_opportunity_fields.forEach(function(ele) {
            ele.field_from = ele.field_type
            ele.field_from = ele.field_type

   
              self.opportunity_fields.push(ele);
             let selected_opp_field = [];

              self.opportunity_fields.forEach(function(ele) {
                if (
                  self.gradeStepDescription.field.some(
                    item => item === ele.name
                  )
                ) {
                  selected_opp_field.push(ele);
                }

                self.gradeStepDescription.opportunity_field = selected_opp_field;
              });


           
          });


          console.log("SELECTED OPPORTUNITY FIELDS",  self.gradeStepDescription.opportunity_field)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    // getAlreadySelectedFields() {
    //   let self = this;
    //   let selected_campaign = {}
    //   selected_campaign.id = self.gradeStepDescription.campaign_id
    //   self.$store
    //     .dispatch(
    //       "campaignsManagement/getAlreadySelectedFields",
    //       selected_campaign
    //     )
    //     .then(response => {
    //       self.already_selected_fields = response.data;
    //       console.log("Already Selected FIELD", self.already_selected_fields);

    //       self.getSelectedAccountFields();
    //       self.getSelectedContactFields();
    //     })
    //     .catch(err => {
    //       if (err.response.status === 404) {
    //         console.log("Error");
    //         return;
    //       }
    //       console.error(err);
    //     });
    // },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                } 
                // else {
                //   mappedArray.push({
                //     id: data[property].id,
                //     name: data[property].company_name + " (Client)",
                //     type: "client"
                //   });
                // }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch("GradesManagement/getAllGradeSteps", params.request)
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.grade_steps.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.grade_steps.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {

      this.$validator.validateAll().then(result => {
        if (result) {
          this.updateGradeSteps();
        }
      });
    },
    updateGradeSteps() {


     if(this.gradeStepDescription.campaign_account_field == undefined){
      this.gradeStepDescription.campaign_account_field = []
     }

     if(this.gradeStepDescription.master_account_field == undefined){
      this.gradeStepDescription.master_account_field = []
     }

     if(this.gradeStepDescription.client_account_field == undefined){
      this.gradeStepDescription.client_account_field = []
     }

     if(this.gradeStepDescription.campaign_contact_field == undefined){
      this.gradeStepDescription.campaign_contact_field = []
     }

     if(this.gradeStepDescription.master_contact_field == undefined){
      this.gradeStepDescription.master_contact_field = []
     }

     if(this.gradeStepDescription.client_contact_field == undefined){
      this.gradeStepDescription.client_contact_field = []
     }

     if(this.gradeStepDescription.opportunity_field == undefined){
      this.gradeStepDescription.opportunity_field = []
     }


     console.log("GRADE STEP DESCRIPTION", this.gradeStepDescription.opportunity_field)


     let mergedArray = [
        ...this.gradeStepDescription.campaign_account_field,
        ...this.gradeStepDescription.master_account_field,
        ...this.gradeStepDescription.client_account_field,
        ...this.gradeStepDescription.campaign_contact_field,
        ...this.gradeStepDescription.master_contact_field,
        ...this.gradeStepDescription.client_contact_field,
        ...this.gradeStepDescription.opportunity_field
      ];
   
      this.gradeStepDescription.fields = mergedArray;

      // mergedArray.map(function(ele){
      //   if(ele.client_field_id !== undefined){
      //     ele.field_from = 'client_field'
      //   }
      //   if(ele.master_field_id !== undefined){
      //     ele.field_from = 'master_field'
      //   }
      //   if(ele.campaign_field_id !== undefined){
      //     ele.field_from = 'campaign_field'
      //   }

      // })



      this.$store
        .dispatch("GradesManagement/updateGradeSteps", this.gradeStepDescription)
        .then(res => {
          this.$vs.notify({
              color: "success",
              title: "Grades Added",
              text: "The grade_steps was update successfully"
            });
                  this.$router.push({ path: `/grade-steps` });

        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
